import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const SignUp = lazyLoad(
  () => import('./index'),
  module => module.SignUp,
  {
    fallback: <LoadingIndicator />,
  },
);
